import React from "react";
import SisliSidebar from "../Sidebar/SisliSidebar";
import SisliOtherServices from "../ServiceAreas/SisliServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const SisliIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        ŞİŞLİ HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            İstanbul’un iş ve yaşam merkezi Şişli’de, halı ve koltuklarınızı derinlemesine temizliyoruz.
            Yaşam alanlarınızda biriken kir, leke, toz ve bakterilerden tamamen arındırılmış ürünlerle
            %100 hijyen sağlıyoruz. Profesyonel ekibimiz, her kumaş ve halı türüne özel çözümler sunar.
          </p>

          <p>
            Koltuk yıkama işlemleri yerinde veya fabrikada yapılabilir. Buharlı, şampuanlı ve fırçalama
            yöntemleriyle koltuklarınızı ilk günkü temizliğine kavuşturuyoruz. Halılar ise tam otomatik
            makinelerde, uygun programlarla yıkanır, kurutulur ve paketlenir.
          </p>

          <p>
            <strong>Şişli'de sunduğumuz avantajlı hizmetlerden bazıları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Şişli ve tüm mahallelerine ücretsiz servis (alım-teslim)</li>
            <li>Antibakteriyel koltuk yıkama sistemleri</li>
            <li>Leke çıkarma garantili işlemler</li>
            <li>Organik temizlik malzemeleri</li>
            <li>Halı, koltuk, perde ve yorgan yıkama hizmetleri</li>
            <li>48 saat içerisinde hızlı teslimat</li>
          </ul>

          <p>
            Nişantaşı, Mecidiyeköy, Okmeydanı, Kurtuluş, Esentepe, Harbiye, Feriköy ve Fulya başta olmak
            üzere Şişli’nin her noktasında mobil ekiplerimizle hizmet sunuyoruz.
          </p>

          <p>
            Halı ve koltuklarınızın temizliğini uzman ellere bırakmak istiyorsanız, hemen bizimle iletişime geçin.
            Web sitemiz veya iletişim numaramızdan sipariş verebilir, fiyat bilgisi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <SisliSidebar />
          <SisliOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default SisliIntro;
